import { EDIT_EVALUATION_HIDE_ASSESSMENTS } from '../../../constants/api'
import errorHandler from '../errorHandler'

export default (
  termNumber: string,
  hideSelf: boolean,
  hideVisitor: boolean,
  token: string
) =>
  fetch(EDIT_EVALUATION_HIDE_ASSESSMENTS(termNumber), {
    method: 'POST',
    headers: {
      Authorization: 'Bearer ' + token,
    },
    body: JSON.stringify({ self: hideSelf, visitor: hideVisitor }),
  }).then(errorHandler)
